export default "__VITE_PUBLIC_ASSET__568c844f__"